import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import { utils } from '../utils/index.js';
import {
  type FabricShareDocumentApi,
  type FabricShareDocumentCallbackData,
  type FabricShareDocumentOption,
  uniformTypeIdentifier,
} from './types.js';

/**
 * IOS文件分享（微信、文件APP）
 */
export const openShareDocument: FabricShareDocumentApi = (
  options: FabricShareDocumentOption
) => {
  return new Promise<FabricShareDocumentCallbackData>((resolve, reject) => {
    if (utils.webview.isIphone()) {
      core.call<
        'fabric_share.showSystemShare',
        FabricShareDocumentOption<string>,
        FabricShareDocumentCallbackData
      >(
        'fabric_share.showSystemShare',
        {
          ...options,
          type: uniformTypeIdentifier[options.type],
        },
        (result) => {
          const fabricErrors = filterFabricErrors(
            result.code,
            result.message,
            result.data
          );
          if (fabricErrors) {
            reject(fabricErrors);
          } else {
            resolve(result.data);
          }
        }
      );
    } else {
      resolve('2');
    }
  });
};
